import ecommerce from "core/pkg/ecommerce";

export const SET_ORDER_SUCCESS = "ORDER/SET_ORDER_SUCCESS";
export const GET_AVAILABLE_ORDER = "ORDER/GET_AVAILABLE_ORDER";
export const SET_ADDRESS_SUCCESS = "ORDER/SET_ADDRESS_SUCCESS";
export const SET_PAYMENT_TYPE_SUCCESS = "PRDER/SET_PAYMENT_TYPE_SUCCESS";
export const SET_ORDER_COMPLETE = "ORDER/SET_ORDER_COMPLETE";
export const SET_ORDER_COMPLETE_ONLINE = "ORDER/SET_ORDER_COMPLETE_ONLINE";
export const SET_PAYMENT_RESULT = "ORDER/SET_PAYMENT_RESULT";
export const SET_GIFT_SUCCESS = "ORDER/SET_GIFT_SUCCESS";

export function setOrderSuccess(order) {
  return {
    type: SET_ORDER_SUCCESS,
    payload: {
      order,
    }
  };
};

export function getAvailableOrderSuccess(order, price) {
  return {
    type: GET_AVAILABLE_ORDER,
    payload: {
      order,
      price,
    }
  };
};

export function setAddressSuccess(order, price) {
  return {
    type: SET_ADDRESS_SUCCESS,
    payload: {
      order,
      price
    }
  };
};

export function setPaymentTypeSuccess(order, price) {
  return {
    type: SET_PAYMENT_TYPE_SUCCESS,
    payload: {
      order,
      price,
    }
  };
};

export function finalizeSuccess(order) {
  return {
    type: SET_ORDER_COMPLETE,
    payload: {
      order,
    }
  };
};

export function finalizeSuccessOnline(gateway) {
  return {
    type: SET_ORDER_COMPLETE_ONLINE,
    payload: {
      gateway,
    }
  };
};

export function checkPaymentResultSuccess(result) {
  return {
    type: SET_PAYMENT_RESULT,
    payload: {
      paymentResult: result,
    }
  };
};

export function giftSuccess(order, price) {
  return {
    type: SET_GIFT_SUCCESS,
    payload: {
      order,
      price,
    }
  };
};

export function setOrder(id) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.setOrder(id)
        .then(r => {
          const order = r.data.order;

          dispatch(setOrderSuccess(order));

          resolve(order);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function getAvailableOrder(id) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.getAvailableOrder(id)
        .then(r => {
          const order = r.data.order;
          const price = r.data.price;

          dispatch(getAvailableOrderSuccess(order, price));

          resolve(order);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function setAddress(id, model, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.setAddress(id, model, params)
        .then(r => {
          const order = r.data.order;
          const price = r.data.price;

          dispatch(setAddressSuccess(order, price));

          resolve(order);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function setPaymentType(id, model, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.setPaymentType(id, model, params)
        .then(r => {
          const order = r.data.order;
          const price = r.data.price

          dispatch(setPaymentTypeSuccess(order, price));

          resolve(order);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function finalize(id, model, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.finalize(id, model, params)
        .then(r => {
          const order = r.data.order;

          dispatch(finalizeSuccess(order));

          resolve(order);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function finalizeOnline(id, model, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.finalizeOnline(id, model, params)
        .then(r => {
          const gateway = r.data;

          dispatch(finalizeSuccessOnline(gateway));

          resolve(gateway);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export function checkPaymentResult(id, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.checkPaymentResult(id, params)
        .then(res => {
          const paymentResult = res.data.paymentResult;
          dispatch(checkPaymentResultSuccess(paymentResult));
          resolve(res.data);
        })
        .catch(e => {
          reject(e);
        });
    })

  }
}

export function gift(id, model, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Order.gift(id, model, params)
        .then(r => {
          const order = r.data.order;
          const price = r.data.price;

          dispatch(giftSuccess(order, price));

          resolve(order);
        })
        .catch(e => {
          reject(e);
        })
    });
  };
};

export default function reducer(
  state = {
    order: null,
    price: null,
    gateway: null,
    paymentResult: null
  },
  { type, payload }
) {
  switch (type) {
    case SET_ORDER_SUCCESS:
      return Object.assign({}, state, {
        order: payload.order
      })

    case GET_AVAILABLE_ORDER:
      return Object.assign({}, state, {
        order: payload.order,
        price: payload.price,
      })

    case SET_ADDRESS_SUCCESS:
      return Object.assign({}, state, {
        order: payload.order,
        price: payload.price,
      })

    case SET_PAYMENT_TYPE_SUCCESS:
      return Object.assign({}, state, {
        order: payload.order,
        price: payload.price,
      })

    case SET_ORDER_COMPLETE:
      return Object.assign({}, state, {
        order: payload.order
      })

    case SET_ORDER_COMPLETE_ONLINE:
      return Object.assign({}, state, {
        gateway: payload.gateway
      })

    case SET_PAYMENT_RESULT:
      return Object.assign({}, state, {
        paymentResult: payload.paymentResult
      })

    case SET_GIFT_SUCCESS:
      return Object.assign({}, state, {
        order: payload.order,
        price: payload.price,
      })

    default:
      return state;
  }
}
